import type { FC } from "react";
import { useState } from "react";

import { KEYWORD_GROUP_PREFIX } from "app/services/keyword-groups";
import { translate } from "app/filters/i18nFilter";
import { KeywordsGroupEditorModal } from "app/pages/keyword-analysis/KeywordsGroupEditorModal";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { PageWrapper, NotAvailableWrapper, EmptyStateIcon, Title, SubTitle, AutoCreateButton } from "./StyledComponent";
import { allTrackers } from "app/services/track/track";

const STATE_NAME = "digitalsuite_marketresearch_keywordmarketanalysis_demand_search_trends";
interface ISearchTrendsNotAvailablePageProps {
    keyword: string;
}
const SearchTrendsNotAvailablePage: FC<ISearchTrendsNotAvailablePageProps> = ({ keyword }) => {
    const [isAutoCreateModalOpen, setIsAutoCreateModalOpen] = useState(false);

    const openKeywordGroupCreationModal = () => {
        setIsAutoCreateModalOpen(true);
        allTrackers.dispatchTrackEvent("Button", "click", "Auto Create KW Lists CTA clicked/Not Available Page");
    };
    return (
        <PageWrapper>
            <NotAvailableWrapper>
                <EmptyStateIcon iconName={`no-data-lab-2`} />
                <Title>demand.analysis.search.trends.not.available.page.title</Title>
                <SubTitle>demand.analysis.search.trends.not.available.page.subtitle</SubTitle>
                <SubTitle>demand.analysis.search.trends.not.available.page.subtitle.desc</SubTitle>
                <AutoCreateButton
                    key="new-company-btn"
                    type="primary"
                    iconName="wand"
                    onClick={openKeywordGroupCreationModal}
                >
                    {translate("listItemKeyword.auto.create.keyword.list.button")}
                </AutoCreateButton>
            </NotAvailableWrapper>
            <KeywordsGroupEditorModal
                onClose={() => {
                    setIsAutoCreateModalOpen(false);
                }}
                open={isAutoCreateModalOpen}
                seedKeyword={keyword}
                onSave={(modifiedGroup) =>
                    proNavigator.go(STATE_NAME, {
                        keyword: KEYWORD_GROUP_PREFIX + modifiedGroup.Id,
                    })
                }
            />
        </PageWrapper>
    );
};
export default SearchTrendsNotAvailablePage;
